import {
  withTranslation,
} from 'react-i18next';

import RegattaResultOverallTableView from './RegattaResultOverallTableView';

const TranslatedComponent = withTranslation()(RegattaResultOverallTableView);

const Component = TranslatedComponent;

export default Component;
